import { Box } from '@mui/material';
import 'devices.css';
import PhonePreview from './PhonePreview';

export default function AppPreview() {
    return (
        <Box sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            py: 2
        }}>
            <div className="device device-iphone-14" style={{ transform: 'scale(0.8)' }}>
                <div className="device-frame">
                    <div className="device-screen" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                        <PhonePreview />
                    </div>
                </div>
                <div className="device-stripe"></div>
                <div className="device-header"></div>
                <div className="device-sensors"></div>
                <div className="device-btns"></div>
                <div className="device-power"></div>
            </div>
        </Box>
    );
}